import React from 'react';
import classNames from 'classnames';
import RcInputNumber from 'rc-input-number';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import { cloneElement } from 'antd/lib/_util/reactNode';
import { Icon } from '../icon';
import warning from 'antd/es/_util/warning';
const InputNumber = React.forwardRef((props, ref) => {
    const { getPrefixCls, direction, animation } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const [focused, setFocus] = React.useState(false);
    const inputRef = React.useRef(null);
    const breathing = 'breathing' in props ? props.breathing : animation?.breathing;
    React.useImperativeHandle(ref, () => inputRef.current);
    const { className, size: customizeSize, prefixCls: customizePrefixCls, addonBefore, addonAfter, state, prefix, bordered = true, readOnly, type, ...others } = props;
    const { disabled } = props;
    const { controls = true } = props;
    const prefixCls = getPrefixCls('input-number', customizePrefixCls);
    const upIcon = type == 'inline' ? React.createElement(Icon, { type: 'add' }) : React.createElement(Icon, { type: 'caret--up' });
    const downIcon = type == 'inline' ? React.createElement(Icon, { type: 'subtract' }) : React.createElement(Icon, { type: 'caret--down' });
    const newaddonBefore = addonBefore;
    const newaddonAfter = addonAfter;
    const mergeSize = customizeSize || size;
    if (process.env.NODE_ENV !== 'production')
        warning(props.theme !== 'gray', 'inputNumber', `'themes = gray' is deprecated now`);
    warning(bordered !== false, 'input', `'bordered = false' is deprecated now`);
    const inputNumberClass = classNames({
        [`${prefixCls}-lg`]: mergeSize === 'large',
        [`${prefixCls}-sm`]: mergeSize === 'small',
        [`${prefixCls}-xs`]: mergeSize === 'xs',
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-error`]: state === 'error',
        [`${prefixCls}-inline`]: type === 'inline',
        [`${prefixCls}-readonly`]: readOnly,
        [`${prefixCls}-nohandler`]: !controls,
        [`${prefixCls}-breathing`]: breathing
    }, className);
    let element = (React.createElement(RcInputNumber, { ref: inputRef, className: inputNumberClass, upHandler: upIcon, downHandler: downIcon, prefixCls: prefixCls, readOnly: readOnly, ...others }));
    if (prefix != null) {
        const affixWrapperCls = classNames(`${prefixCls}-affix-wrapper`, {
            [`${prefixCls}-affix-wrapper-focused`]: focused,
            [`${prefixCls}-affix-wrapper-disabled`]: props.disabled,
            [`${prefixCls}-affix-wrapper-sm`]: size === 'small',
            [`${prefixCls}-affix-wrapper-lg`]: size === 'large',
            [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
            [`${prefixCls}-affix-wrapper-readonly`]: readOnly,
            [`${prefixCls}-affix-wrapper-borderless`]: !bordered,
            // className will go to addon wrapper
            [`${className}`]: !(addonBefore || addonAfter) && className
        });
        element = (React.createElement("div", { className: affixWrapperCls, style: props.style, onMouseUp: () => inputRef.current.focus() },
            React.createElement("span", { className: `${prefixCls}-prefix` }, prefix),
            cloneElement(element, {
                style: null,
                value: props.value,
                onFocus: (event) => {
                    setFocus(true);
                    props.onFocus?.(event);
                },
                onBlur: (event) => {
                    setFocus(false);
                    props.onBlur?.(event);
                }
            })));
    }
    if (newaddonBefore != null || newaddonAfter != null) {
        const wrapperClassName = `${prefixCls}-group`;
        const addonClassName = `${wrapperClassName}-addon`;
        const addonBeforeNode = newaddonBefore ? React.createElement("div", { className: addonClassName }, newaddonBefore) : null;
        const addonAfterNode = newaddonAfter ? React.createElement("div", { className: addonClassName }, newaddonAfter) : null;
        const mergedWrapperClassName = classNames(`${prefixCls}-wrapper`, wrapperClassName, {
            [`${wrapperClassName}-rtl`]: direction === 'rtl'
        });
        const mergedGroupClassName = classNames(`${prefixCls}-group-wrapper`, {
            [`${prefixCls}-group-wrapper-xs`]: mergeSize === 'xs',
            [`${prefixCls}-group-wrapper-sm`]: mergeSize === 'small',
            [`${prefixCls}-group-wrapper-lg`]: mergeSize === 'large',
            [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
            [`${prefixCls}-group-wrapper-disabled`]: disabled,
            [`${prefixCls}-group-wrapper-error`]: state === 'error'
        }, className);
        return (React.createElement("div", { className: mergedGroupClassName, style: props.style },
            React.createElement("div", { className: mergedWrapperClassName },
                addonBeforeNode,
                cloneElement(element, { style: null }),
                addonAfterNode)));
    }
    return element;
});
InputNumber;
export { InputNumber };
// export default withConfigProvider(InputNumber);
export default InputNumber;
